import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'


const ContractFormStepApproval = ({useFetchInit}) => {
  
    const {
        //------------- Generales
        defaultData,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {stepApplilication} = globalStates
    const {handleClickReturnStep, handleClickNextStep} = Actions

    const { FormLeases } = Forms
    const { onInputChange, formState, onSelectSearchChange } = FormLeases
    

    return (
        <>
            <Typography variant="caption"> 
                * Disponible cuando la solicitud haya sido respondida (NO EDITABLE):
            </Typography>
            <div className="border-bottom border-dark"></div>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_check">* Estado Aprobación</label>
                        <CustomAutocomplete 
                            customId="aprobacion_check"
                            customName="aprobacion_check"
                            customValue={formState.aprobacion_check}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'aprobacion_check', value: value.value }})}
                            customPlaceholder='Seleccionar un modo'
                            customOptions={
                                defaultData.optionsAprobacionCheck.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled = {true}    
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_fecha">* Fecha marcaje</label>
                        <TextField
                            id='aprobacion_fecha'
                            name='aprobacion_fecha'
                            value={ formState.aprobacion_fecha }
                            onChange={ onInputChange }
                            placeholder='Fecha de pago'
                            size='small'
                            type='date'
                            hiddenLabel
                            variant="filled"
                            required
                            InputProps={{
                                readOnly: true
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_observaciones">Observaciones</label>
                        <TextField 
                            id='aprobacion_observaciones'
                            name='aprobacion_observaciones'
                            value={ formState.aprobacion_observaciones }
                            onChange={ onInputChange }
                            placeholder='Observaciones'
                            type='text'
                            size='small'
                            hiddenLabel
                            multiline
                            rows={5}
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="text-center">
                    {stepApplilication !== 0 && (
                        <Button 
                            startIcon={<ArrowLeftCircle/>}
                            variant="contained"
                            type="button"
                            onClick={handleClickReturnStep} 
                            sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                        >
                            Volver
                        </Button>
                    )}

                        <Button
                            endIcon={<ArrowRightCircle/>}
                            variant="contained"
                            type="button"
                            style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                            onClick={handleClickNextStep}
                        >       
                            {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                        </Button>
                </div>
        </>
    )
    
}

export {
    ContractFormStepApproval
}